import { MediaCard } from '@shopify/polaris'

import { useLocalStorage } from '../common/local-storage'

export const GlowCard = () => {
  const [dismissed, setDismissed] = useLocalStorage<boolean>('glow-card-dismissed', false)

  if (dismissed) return null

  return (
    <MediaCard
      title="Reward Your Subscribers"
      primaryAction={{
        content: 'Start Rewarding Today',
        onAction: () => {
          window.open('https://apps.shopify.com/glow-loyalty', '_blank')
        },
      }}
      description="With Glow Loyalty, shoppers earn points for purchasing, sharing, and more—then redeem them for exclusive discounts and rewards whenever they're ready."
      onDismiss={() => setDismissed(true)}
    >
      <img
        alt=""
        width="100%"
        height="100%"
        style={{
          objectFit: 'cover',
          objectPosition: 'center',
        }}
        src="/images/glow-features-page.png"
      />
    </MediaCard>
  )
}
